
/**
 * Utility to cleanup any development examples that might be showing in the DOM
 * This should be called on app mount to ensure no development code is visible to users
 */
export const cleanupDevelopmentExamples = () => {
  // Function to run on load to remove any Reddit pixel example code
  const removeRedditExamples = () => {
    // Look for text nodes containing Reddit pixel example code
    const textNodes = [];
    const walk = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      null
    );
    
    let node;
    while (node = walk.nextNode()) {
      if (node.textContent && 
          (node.textContent.includes("rdt('init'") || 
           node.textContent.includes("Example: Share a conversion"))) {
        textNodes.push(node);
      }
    }
    
    // Remove any nodes containing the example code
    textNodes.forEach(node => {
      // If the node is directly in the body or a main container, remove it
      if (node.parentNode) {
        // Check if it's just a text node with no other content
        if (node.parentNode.childNodes.length === 1 && 
            node.parentNode.tagName !== 'SCRIPT' && 
            node.parentNode.tagName !== 'STYLE') {
          node.parentNode.remove();
        } else {
          node.remove();
        }
      }
    });
  };

  // Execute cleanup
  removeRedditExamples();

  // Also attach to the window load event to ensure it runs after everything is loaded
  window.addEventListener('load', removeRedditExamples);
};
